export const NotificationSettings = {
	// items used for creating array of checkbox list on the notification page
	Id: {
		name: "id",
		displayName: "id",
		beName: "id",
	},
	AllowedNotifications: {
		name: "allowedNotifications",
		displayName: "",
		beName: "allowed_notifications",
	},
	ApplicationEquipmentIsCompletedAndMovedToInstallation: {
		name: "applicationEquipmentIsCompletedAndMovedToInstallation",
		displayName:
			"Application TID & Equipment request is completed and moved to Installation request",
		beName: "application_equipment_is_completed_and_moved_to_installation",
	},

	ApplicationIsApprovedByUwAndMovedToBoarding: {
		name: "applicationIsApprovedByUwAndMovedToBoarding",
		displayName:
			"Application is approved by Underwriting and moved to Boarding",
		beName: "application_is_approved_by_uw_and_moved_to_boarding",
	},
	ApplicationIsApprovedFromUwConcurrence: {
		name: "applicationIsApprovedFromUwConcurrence",
		displayName:
			"Application is updated to Underwriting approved after sponsor bank review", // ?
		beName: "application_is_approved_from_uw_concurrence",
	},
	ApplicationIsApprovedPendingConcurrence: {
		name: "applicationIsApprovedPendingConcurrence",
		displayName:
			"Application is approved, pending concurrence and moved to Boarding",
		beName: "application_is_approved_pending_concurrence",
	},

	ApplicationIsApprovedWithConditions: {
		name: "applicationIsApprovedWithConditions",
		displayName:
			"Application is approved with conditions and moved to Boarding",
		beName: "application_is_approved_with_conditions",
	},
	ApplicationIsCompleted: {
		name: "applicationIsCompleted",
		displayName: "Application is completed",
		beName: "application_is_completed",
	},
	ApplicationIsDeclinedFromUw: {
		name: "applicationIsDeclinedFromUw",
		displayName: "Application is declined by Underwriting",
		beName: "application_is_declined_from_uw",
	},
	ApplicationIsDeclinedFromUwConcurrence: {
		name: "applicationIsDeclinedFromUwConcurrence",
		displayName:
			"Application is updated to Underwriting declined after sponsor bank review", //?
		beName: "application_is_declined_from_uw_concurrence",
	},
	ApplicationIsPended: {
		name: "applicationIsPended",
		displayName: "Pended Application",
		beName: "application_is_pended",
	},
	ApplicationIsRejectedByBoarding: {
		name: "applicationIsRejectedByBoarding",
		displayName: "Application is rejected by Boarding",
		beName: "application_is_rejected_by_boarding",
	},
	ApplicationIsSignedAndMovedToUw: {
		name: "applicationIsSignedAndMovedToUw",
		displayName: "Application is signed and submitted to Underwriting",
		beName: "application_is_signed_and_moved_to_uw",
	},
	BoardingIsCompleted: {
		name: "boardingIsCompleted",
		displayName:
			"Application Boarding is completed and moved to TID & Equipment request",
		beName: "boarding_is_completed",
	},
	MerchantFirstBatchIsSettled: {
		name: "merchantFirstBatchIsSettled",
		displayName: "Merchant First Batch is settled",
		beName: "merchant_first_batch_is_settled",
	},
	MerchantLoanAccepted: {
		name: "merchantLoanAccepted",
		displayName: "Merchant Loan is accepted",
		beName: "merchant_loan_accepted",
	},
	MpaAppMovedToUw: {
		name: "mpaAppMovedToUw",
		displayName: "Paper application is submitted to Underwriting", //?
		beName: "mpa_app_moved_to_uw",
	},
	PendDetailsUpdated: {
		name: "pendDetailsUpdated",
		displayName: "Pend details updated",
		beName: "pend_details_updated",
	},
	PendResponseSubmitted: {
		name: "pendResponseSubmitted",
		displayName: "Pend response submitted",
		beName: "pend_response_submitted",
	},
	PendStatusUpdated: {
		name: "pendStatusUpdated",
		displayName: "Pend status updated",
		beName: "pend_status_updated",
	},
	PreApplicationIsCreated: {
		name: "preApplicationIsCreated",
		displayName: "Pre-application is created",
		beName: "pre_application_is_created",
	},
	PreApplicationIsSubmittedByMerchant: {
		name: "preApplicationIsSubmittedByMerchant",
		displayName: "Pre-application in pending completion status", // ?
		beName: "pre_application_is_submitted_by_merchant",
	},
	RetailApplicationIsSubmittedToBoarding: {
		name: "retailApplicationIsSubmittedToBoarding",
		displayName: "Retail - Application is submitted to Boarding",
		beName: "retail_application_is_submitted_to_boarding",
	},
};
